/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Objects of type BalenaDeviceNotificationMessage are sent to hub method named balenaDeviceNotificationMessage in the device group device_<deviceId>. Listen to it via `signalRHub.on('balenaDeviceNotificationMessage', (message: BalenaDeviceNotificationMessage) => {}`
 * @export
 * @interface BalenaDeviceNotificationMessage
 */
export interface BalenaDeviceNotificationMessage {
    /**
     *
     * @type {string}
     * @memberof BalenaDeviceNotificationMessage
     */
    deviceId?: string;
    /**
     *
     * @type {string}
     * @memberof BalenaDeviceNotificationMessage
     */
    deviceUUID?: string;
    /**
     *
     * @type {number}
     * @memberof BalenaDeviceNotificationMessage
     */
    runningReleaseId?: number;
    /**
     *
     * @type {number}
     * @memberof BalenaDeviceNotificationMessage
     */
    targetReleaseId?: number;
    /**
     *
     * @type {string}
     * @memberof BalenaDeviceNotificationMessage
     */
    updateStatus?: BalenaDeviceNotificationMessageUpdateStatusEnum;
    /**
     *
     * @type {string}
     * @memberof BalenaDeviceNotificationMessage
     */
    deviceType?: BalenaDeviceNotificationMessageDeviceTypeEnum;
}

/**
 * @export
 */
export const BalenaDeviceNotificationMessageUpdateStatusEnum = {
    Rejected: "rejected",
    Downloading: "downloading",
    Downloaded: "downloaded",
    ApplyingChanges: "applying changes",
    Aborted: "aborted",
    Done: "done",
} as const;
export type BalenaDeviceNotificationMessageUpdateStatusEnum =
    (typeof BalenaDeviceNotificationMessageUpdateStatusEnum)[keyof typeof BalenaDeviceNotificationMessageUpdateStatusEnum];

/**
 * @export
 */
export const BalenaDeviceNotificationMessageDeviceTypeEnum = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;
export type BalenaDeviceNotificationMessageDeviceTypeEnum =
    (typeof BalenaDeviceNotificationMessageDeviceTypeEnum)[keyof typeof BalenaDeviceNotificationMessageDeviceTypeEnum];

/**
 * Check if a given object implements the BalenaDeviceNotificationMessage interface.
 */
export function instanceOfBalenaDeviceNotificationMessage(
    value: object,
): value is BalenaDeviceNotificationMessage {
    return true;
}

export function BalenaDeviceNotificationMessageFromJSON(
    json: any,
): BalenaDeviceNotificationMessage {
    return BalenaDeviceNotificationMessageFromJSONTyped(json, false);
}

export function BalenaDeviceNotificationMessageFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): BalenaDeviceNotificationMessage {
    if (json == null) {
        return json;
    }
    return {
        deviceId: json["deviceId"] == null ? undefined : json["deviceId"],
        deviceUUID: json["deviceUUID"] == null ? undefined : json["deviceUUID"],
        runningReleaseId:
            json["runningReleaseId"] == null
                ? undefined
                : json["runningReleaseId"],
        targetReleaseId:
            json["targetReleaseId"] == null
                ? undefined
                : json["targetReleaseId"],
        updateStatus:
            json["updateStatus"] == null ? undefined : json["updateStatus"],
        deviceType: json["deviceType"] == null ? undefined : json["deviceType"],
    };
}

export function BalenaDeviceNotificationMessageToJSON(
    value?: BalenaDeviceNotificationMessage | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceId: value["deviceId"],
        deviceUUID: value["deviceUUID"],
        runningReleaseId: value["runningReleaseId"],
        targetReleaseId: value["targetReleaseId"],
        updateStatus: value["updateStatus"],
        deviceType: value["deviceType"],
    };
}
